import React, { useContext } from 'react';
import axios from 'axios';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { urlConfig } from '../../../config/urlConfig';
import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';
import { GlobalContext } from '../../../services/global/GlobalState';
import { useHistory } from 'react-router';
import { Button } from '@material-ui/core';
import { FaFacebook } from 'react-icons/fa';
import { makeStyles } from '@material-ui/styles';
import { AuthenticationContext } from '../../../services/authentication/authentication.context';

const useStyle = makeStyles((theme) => {
  return {
    facebookIcon: {
      marginRight: 30,
      color: '#3b5998',
    },
    Button: {
      display: 'flex',
      justifyContent: 'start',
    },
  };
});

export default function LoginWithFacebook({ setFormError }) {
  const { expirationDate } = useContext(GlobalContext);
  const { setUserData, setUserPreferTime } = useContext(AuthenticationContext);
  const history = useHistory();
  const classes = useStyle();

  const responseFacebook = (response) => {
    setUserData(null);
    setUserPreferTime(null);

    let decode = '';
    axios
      .post(urlConfig.login_with_facebook, {
        access_token: response.accessToken,
      })
      .then((res) => {
        decode = jwt_decode(res.data.refresh_token);
        expirationDate(decode.exp);
        setUserData(res.data.user);
        Cookies.set('access_token', res.data.access_token, {
          expires: 365,
          secure: true,
          sameSite: 'none',
          path: '/',
        });
        Cookies.set('refresh_token', res.data.refresh_token, {
          expires: 365,
          secure: true,
          sameSite: 'none',
          path: '/',
        });
        history.push('/meetings');
      })
      .catch((err) => {
        setFormError(err.toString());
        console.log(`login err: `, err);
        console.log(`login err: `, err.response);
      });
  };
  return (
    <FacebookLogin
      appId='899740784279900'
      fields='name,email'
      permissions={['email']}
      callback={responseFacebook}
      icon='fa-facebook'
      render={(renderProps) => (
        <Button
          onClick={renderProps.onClick}
          className={classes.Button}
          variant='outlined'
          startIcon={<FaFacebook className={classes.facebookIcon} />}
        >
          Continue with Facebook
        </Button>
      )}
    />
  );
}
